import { type ReactNode, createContext, useContext } from "react";
import { useGetSessionSuspenseQuery } from "../api/routes/session.ts";

interface SessionContext {
    accountId: string;
    userDisplayName: string;
}

const SessionContext = createContext<SessionContext | undefined>(undefined);

/**
 * This fetches the archive specific session. This is useful for redirects if the user has no access.
 */
interface SessionProviderProps {
    children: ReactNode;
}

export const SessionProvider = ({ children }: SessionProviderProps) => {
    const { data: session } = useGetSessionSuspenseQuery();

    return (
        <SessionContext.Provider
            value={{
                accountId: session.accountId,
                userDisplayName: session.userDisplayName
            }}
        >
            {children}
        </SessionContext.Provider>
    );
};

export const useSession = () => {
    const context = useContext(SessionContext);

    if (!context) {
        throw new Error("useSession must be used within a SessionProvider");
    }

    return context;
};
